<template>
  <v-app id="app">
    <Sidebar v-if="!anonymous" />
    <Topbar v-if="!anonymous" />
    <v-main>
      <router-view @scrollTop="scrollTop" />

      <AppNotifications />
      <!-- <v-alert
        max-width="400px"
        v-for="(notification, index) of this.$store.state.notificationsStore
          .notifications"
        :dark="!notification.type"
        :key="index"
        closable
        style="z-index: 999"
        class="position-absolute bottom-0 right-0 mr-4 mb-4"
        :class="{
          animate__fadeOutRight: notification.animation,
          accent: !notification.type,
        }"
        :type="notification.type"
      >
        <v-row align="center">
          <v-col class="grow">
            <span v-html="notification.text"></span>
            <div v-if="notification.subtext">
              <small v-html="notification.subtext"></small>
            </div>
          </v-col>
          <v-col v-if="notification.action" class="shrink">
            <v-btn
              color="primary"
              size="small"
              @click="$router.push(notification.action)"
              ><span v-html="notification.buttonText"></span
            ></v-btn>
          </v-col>
        </v-row>
      </v-alert> -->

      <v-dialog
        v-if="currentUser"
        v-model="currentUser.changePasswordOnNextLogin"
        persistent
        max-width="800px"
      >
        <v-card class="rounded-elephant">
          <v-card-title class="text-h5 ml-2">
            Bitte ändern Sie Ihr Passwort
          </v-card-title>
          <v-card-text>
            <v-container>
              <p>
                Mit diesen Daten können Sie sich dann jederzeit im Elephant
                Kundenportal einloggen.
              </p>
              <v-form v-model="valid">
                <!-- <v-text-field
                  label="E-Mail"
                  placeholder="Email"
                  disabled
                  v-model="currentUser.email"
                ></v-text-field> -->
                <v-text-field
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  disabled
                  label="E-Mail"
                  type="email"
                  v-model="currentUser.email"
                  required
                  rounded
                  class="mt-5 w-100"
                />

                <v-text-field
                  prepend-inner-icon="mdi-lock-outline"
                  label="Passwort"
                  variant="outlined"
                  :rules="passwordRules"
                  v-model="newPassword"
                  :append-inner-icon="
                    passwordVisible ? 'mdi-eye-off' : 'mdi-eye'
                  "
                  :type="passwordVisible ? 'text' : 'password'"
                  @click:append-inner="passwordVisible = !passwordVisible"
                  required
                  rounded
                  class="mb-0 pb-0"
                />
                <v-checkbox
                  v-model="acceptAGB"
                  color="accent"
                  label="Ich akzepiere dass Elephant meine Daten speichert, sowie die AGB & Datenschutz"
                ></v-checkbox>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              block
              class="rounded-xl"
              :disabled="!valid || !acceptAGB"
              @click="changePassword"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <SuccessDialog v-if="!anonymous" />
    </v-main>
    <!-- <v-footer app>
      <Mobilebar class="hidden-lg-and-up" />
    </v-footer> -->
  </v-app>
</template>

<script>
import Topbar from "@/views/Navigation/Topbar";
import Sidebar from "@/views/Navigation/Sidebar";
// import Mobilebar from "@/views/Navigation/Mobilebar";
import { changePassword } from "@/services/user.service";
import SuccessDialog from "@/views/Prozesse/OnBoarding/SuccessDialog";
import AppNotifications from "@/AppNotifications.vue";
//TODO Add Frontend to see Processes and Projects; And remove old DME STuff
export default {
  name: "AppVue",
  components: {
    AppNotifications,
    // Mobilebar,
    Topbar,
    Sidebar,
    SuccessDialog,
  },
  data() {
    return {
      acceptAGB: false,
      heightNav: null,
      deferredPrompt: null,
      newPassword: "",
      passwordVisible: false,
      valid: false,
      passwordRules: [
        (v) => !!v || this.$t("login.passwordRequired"),
        (value) => {
          const pattern =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
          return (
            pattern.test(value) ||
            "Mindestens 8 Zeichen mit mindestens einem Großbuchstaben, einer Zahl und einem Sonderzeichen."
          );
        },
      ],
    };
  },

  created() {
    this.installPWA();
    //this.loadContacts();
    //if(this.currentUser) this.registerFirebase();
  },
  computed: {
    anonymous() {
      return this.$route.meta.anonymous;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    dark() {
      return this.$vuetify.theme.dark;
    },
  },
  mounted() {
    this.$store.state.app.initialHistory = window.history.length;
  },
  methods: {
    changePassword() {
      console.log("Change PW", this.newPassword);
      changePassword(this.newPassword);

      //this.currentUser.changePasswordOnNextLogin=false;
    },
    scrollTop() {
      this.$nextTick(() => {
        console.log("Scrolling top", this.$refs.mainContainer);
        this.$refs.mainContent.scrollTop = 0;
      });
    },
    async dismiss() {
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    installPWA() {
      console.log("PWA Install?");
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
        console.log("Prompt " + e);
      });
      window.addEventListener("appinstalled", () => {
        console.log("app installed");
        this.deferredPrompt = null;
      });
    },

    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },
};
</script>

<style>
#mainContainer {
  min-height: 100vh;
}
@media screen and (max-width: 600px) {
  #mainContainer {
    margin-top: 60px;
    min-height: 100vh;
  }
}
.customTooltip * {
  color: #ffffff;
  font-size: 18px;
  border-radius: 8px;
}

.customTooltip .introjs-tooltip-title {
  color: #ffffff;
}
.customButton {
  background-color: #ffffff;
  border-radius: 12px;
  font-size: 18px;
  padding: 5px 10px;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.customButton:hover {
  background-color: #f0f0f0;
}
</style>
